import { PageCard } from "src/common/styles/styles"
import { useEffect } from "react"
import { SystemDescriptions } from "src/common/descriptions"
import useUserPermission from "src/hooks/useUserPermissions"
import { USER_SCOPES } from "src/hooks/UserPermission"
import { ContractPaymentComponent } from "../ContractPaymentComponent"

export const ContractPayments = () => {
    const { validateUserScopeForPage } = useUserPermission()

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.SERVICE_CONTRACT_DEBIT_PAYMENT_READ)
    }, [])

    const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CONTRACT_PAYMENTS

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
        >
            <ContractPaymentComponent />
        </PageCard>
    )
}
